
























































































import { Component, Emit, Prop } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import { orderBy } from 'lodash'
import DataTable from '@/components/molecules/DataTable/DataTable.vue'
import {
  Col,
  findSortColumnItem,
  setSortOrder,
  SortColumn
} from '@/components/molecules/DataTable'
import { CollectionFlag, SearchType, SortOrder } from '@/types'
import { PAGE_LEND_RESET } from '@/config/event'
import { RemindHistory, SystemCode } from '@/api'
import IconBibliography from '@/components/molecules/IconBibliography/IconBibliography.vue'

const COLS: Col[] = [
  {
    width: 50,
    items: [
      {
        name: 'no',
        align: 'right'
      }
    ]
  },
  {
    width: '30',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'displayTitle',
        headerText: 'タイトル',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'collectionNo',
        headerText: '資料番号',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '15',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'reminderTime',
        headerText: '督促日時',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'reminderName',
        headerText: '督促者',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '10',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'reminderType',
        headerText: '督促方法',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: '25',
    resizable: true,
    movable: true,
    items: [
      {
        name: 'reminderMemo',
        headerText: 'メモ',
        sortable: true,
        sortOrder: ''
      }
    ]
  },
  {
    width: 30,
    resizable: true,
    movable: true,
    items: [
      {
        name: 'remove',
        headerText: '',
        align: 'center'
      }
    ]
  }
]

@Component({
  components: {
    IconBibliography,
    DataTable
  }
})
export default class RemindHistoryTable extends ComponentVue {
  @Prop({
    type: Array
  })
  items!: RemindHistory[]

  @Prop({
    type: Number
  })
  height!: number

  @Prop({
    type: Boolean,
    default: true
  })
  edit!: number

  sortName: string = ''

  sortOrder: SortOrder = ''

  get allCols(): Col[] {
    return COLS
  }

  get cols(): Col[] {
    if (this.edit) {
      return this.allCols
    }
    return this.allCols.filter((item: Col) => {
      return item.items[0].name !== 'remove'
    })
  }

  get sortedItems(): RemindHistory[] {
    if (this.sortName) {
      return orderBy<RemindHistory>(
        this.items,
        (item: RemindHistory) => {
          if (this.sortName === 'displayTitle') {
            return item.displayTitle + item.displayAuthor
          }

          const propertyValue = item[this.sortName as keyof RemindHistory]
          const type: string = Object.prototype.toString
            .call(propertyValue)
            .slice(8, -1)
            .toLowerCase()

          if (type === 'object') return (propertyValue as SystemCode).shortName

          return propertyValue
        },
        this.sortOrder as 'asc' | 'desc'[]
      )
    }

    return this.items
  }

  activated() {
    this.$eventBus.on(PAGE_LEND_RESET, this.initializeDataProperty)
  }

  deactivated() {
    this.$eventBus.off(PAGE_LEND_RESET)
  }

  @Emit('remove')
  onClickRemove(id: number) {
    return id
  }

  isSearchTypeMagazine(code: string): boolean {
    return code === SearchType.Magazine
  }

  initializeDataProperty(): void {
    this.sortName = ''
    this.sortOrder = ''
  }

  isCollectionFlagCollection(collectionFlag: CollectionFlag): boolean {
    return collectionFlag === CollectionFlag.Collection
  }

  onSort(sortColumn: SortColumn) {
    setSortOrder(this.cols, sortColumn)

    const sortColItem = findSortColumnItem(this.cols)

    this.sortName = sortColItem?.name ?? ''
    this.sortOrder = sortColItem?.sortOrder ?? ''
  }
}
